import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { checkVersionAndClearCache } from "utils/versionCheck";

const useVersionCheck = (): boolean => {
  const [isVersionChecked, setIsVersionChecked] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const initializeVersionCheck = async () => {
      try {
        await checkVersionAndClearCache();
      } catch (error) {
        console.error("Error during version check:", error);
      } finally {
        setIsVersionChecked(true);
      }
    };

    initializeVersionCheck();
  }, [location.pathname]);

  return isVersionChecked;
};

export { useVersionCheck };
